import { useEffect, useState } from "react";

const storageKey = "appnotes:console:theme";
type Theme = "light" | "dark";

function storedTheme(): Theme | null {
  try {
    const value = window.localStorage.getItem(storageKey);
    return value === "light" || value === "dark" ? value : null;
  } catch {
    return null;
  }
}

/** Light by default; keep an explicit choice saved in this browser. */
export function useTheme(): {
  readonly dark: boolean;
  readonly toggle: () => void;
} {
  const [choice, setChoice] = useState<Theme | null>(storedTheme);
  const dark = choice === "dark";

  useEffect(() => {
    const storageChanged = (event: StorageEvent) => {
      if (event.key === storageKey || event.key === null)
        setChoice(storedTheme());
    };
    window.addEventListener("storage", storageChanged);
    return () => window.removeEventListener("storage", storageChanged);
  }, []);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    document.documentElement.style.colorScheme = dark ? "dark" : "light";
  }, [dark]);

  return {
    dark,
    toggle: () => {
      const next = dark ? "light" : "dark";
      setChoice(next);
      try {
        window.localStorage.setItem(storageKey, next);
      } catch {
        // The choice still works for this visit when browser storage is denied.
      }
    },
  };
}
